import { API } from './api';
import { APICallMethod } from './const';

const DSP_HANDLE = "/event/dsp";
const DSP_EVENTS = {
  event: 'rtb',
  event2: 'request',
};

export const createLogger = ({ sid, zone, config, socket }) => {
  const logUrl = config.ldom;

  const baseTrackingEvents = {
    start: [`https://${logUrl}/event/player?aid=(aid)&sid=(sid)&tid=(tid)&zone=(zone)&event=rtb&event2=start&cb=(cb)&n=(views)&tg=(tg)&tu=(tu)`],
    impression: [`https://${logUrl}/event/player?aid=(aid)&sid=(sid)&tid=(tid)&zone=(zone)&event=rtb&event2=impression&cb=(cb)&n=(views)&tg=(tg)&tu=(tu)`],
    complete: [`https://${logUrl}/event/player?aid=(aid)&sid=(sid)&tid=(tid)&zone=(zone)&event=rtb&event2=complete&cb=(cb)&n=(views)&tg=(tg)&tu=(tu)`],
    pause: [`https://${logUrl}/event/player?aid=(aid)&sid=(sid)&tid=(tid)&zone=(zone)&event=rtb&event2=pause&cb=(cb)&n=(views)&tg=(tg)&tu=(tu)`],
    resume: [`https://${logUrl}/event/player?aid=(aid)&sid=(sid)&tid=(tid)&zone=(zone)&event=rtb&event2=resume&cb=(cb)&n=(views)`],
    firstQuartile: [`https://${logUrl}/event/player?aid=(aid)&sid=(sid)&tid=(tid)&zone=(zone)&event=rtb&event2=firstQuartile&cb=(cb)&n=(views)&tg=(tg)&tu=(tu)`],
    midpoint: [`https://${logUrl}/event/player?aid=(aid)&sid=(sid)&tid=(tid)&zone=(zone)&event=rtb&event2=midpoint&cb=(cb)&n=(views)&tg=(tg)&tu=(tu)`],
    thirdQuartile: [`https://${logUrl}/event/player?aid=(aid)&sid=(sid)&tid=(tid)&zone=(zone)&event=rtb&event2=thirdQuartile&cb=(cb)&n=(views)&tg=(tg)&tu=(tu)`],
    click: [`https://${logUrl}/event/player?aid=(aid)&sid=(sid)&tid=(tid)&zone=(zone)&event=rtb&event2=click&cb=(cb)&n=(views)&tg=(tg)&tu=(tu)`],
    unmute: [`https://${logUrl}/event/player?aid=(aid)&sid=(sid)&tid=(tid)&zone=(zone)&event=rtb&event2=unmute&cb=(cb)&n=(views)&tg=(tg)&tu=(tu)`],
    mute: [`https://${logUrl}/event/player?aid=(aid)&sid=(sid)&tid=(tid)&zone=(zone)&event=rtb&event2=mute&cb=(cb)&n=(views)&tg=(tg)&tu=(tu)`],
    // error: [`https://${logUrl}/event/player?aid=(aid)&sid=(sid)&tid=(tid)&zone=(zone)&event=rtb&event2=error&cb=(cb)&code=(ecode)&n=(views)&tg=(tg)&tu=(tu)`],
    error: [`https://${logUrl}/event/player?aid=(aid)&sid=(sid)&tid=(tid)&zone=(zone)&event=rtb&event2=(ecode)&cb=(cb)&n=(views)&tg=(tg)&tu=(tu)`],
    
    vis: [`https://${logUrl}/event/player?aid=(aid)&sid=(sid)&tid=(tid)&zone=(zone)&event=rtb&event2=vis&cb=(cb)&n=(views)&tg=(tg)&tu=(tu)`],

    muteExtra: [`https://${logUrl}/event/extra?sid=(sid)&tid=(tid)&tu=(tu)&zone=(zone)&event=mute&cb=(cb)&n=(views)&tg=(tg)`],
    unmuteExtra: [`https://${logUrl}/event/extra?sid=(sid)&tid=(tid)&tu=(tu)&zone=(zone)&event=unmute&cb=(cb)&n=(views)&tg=(tg)`]
  };

  const logTagsTrackers = (trackers) => {
    trackers.forEach(({ url }) => API.call(url, {}, { mode: 'no-cors', credentials: 'include' }, APICallMethod.IMAGE));
  }

  const logTags = (tags) => {
    // console.log('log tagsss', tags);
    const { playerVersion } = config;
    let tids = "";
    tags.forEach((tid, index) => {
      if (index !== 0) {
        tids += ",";
      }
      // tids += `${dsp.asid}`;
      tids += `${tid}`;
    });

    const params = {
      ...DSP_EVENTS,
      sid,
      zone,
      tids,
      v: playerVersion,
      cb: Date.now(),
    };
    // const resource = '//' + logUrl + DSP_HANDLE;

    if (config.ws) {
      socket.send(`type=dsp&event=rtb&event2=request&sid=${params.sid}&zone=${params.zone}&tids=${params.tids}&cb=${params.cb}`);
    } else {
      const resource = '//' + logUrl + DSP_HANDLE;
      
      return API.call(resource, params, { mode: 'no-cors' }, APICallMethod.IMAGE)
    }
    // type=dsp&event=rtb&event2=request&sid=101798&zone=22&tids=14115%2C577&v=209131&cb=1663584286815
  }

  return ({
    logTags,
    logTagsTrackers,
    baseTrackingEvents
  });
}
